import { args } from '../common/args';
import { defineCapability } from './internal';
export const SHOW_DEMO_EXIT_CONFIRMATION_CAP = defineCapability({
  name: 'SHOW_DEMO_EXIT_CONFIRMATION_CAP',
  args: {
    appSource: args.string(),
    url: args.string()
  }
});